import {
  createBaseQuery,
  createServerSideRequestOption,
  getBaseUrl,
} from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";

export const getCompanyServices = async ({
  companyId,
  request,
}: {
  companyId: number;
  request: Request;
}) => {
  return await createServerSideRequestOption({
    url: `${getBaseUrl()}/api/v1/c/${companyId}/services`,
    request: request,
    method: "GET",
  });
};

export const getCompanyAllUserServices = async ({
  companyId,
  request,
}: {
  companyId: number;
  request: Request;
}) => {
  return await createServerSideRequestOption({
    url: `${getBaseUrl()}/api/v1/c/${companyId}/services/user`,
    request: request,
    method: "GET",
  });
};

export const companyServiceApi = createApi({
  reducerPath: "companyServiceApi",
  baseQuery: createBaseQuery("/c/"),
  tagTypes: ["companyService", "generalServices"],
  endpoints: (build) => ({
    loadServices: build.query<CompanyService[], { companyId: number }>({
      query: ({ companyId }) => ({
        url: `/${companyId}/services`,
        method: "GET",
      }),
    }),
    loadAllServices: build.query<CompanyService[], { companyId: number }>({
      query: ({ companyId }) => ({
        url: `/${companyId}/services`,
        method: "GET",
      }),
    }),
    createService: build.mutation<
      CompanyService,
      { companyId: number; data: CompanyServiceData }
    >({
      query: ({ companyId, data }) => ({
        url: `/${companyId}/services`,
        method: "POST",
        body: data,
      }),
    }),
    editService: build.mutation<
      CompanyService,
      { companyId: number; serviceId: number; data: CompanyServiceData }
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: `/${companyId}/services/${serviceId}`,
        method: "PUT",
        body: data,
      }),
    }),
  }),
});
